var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 30,
    viewBox: "0 0 57 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8885 20.3132C8.48168 22.175 5.31877 23.4015 0.050293 23.3574C8.24131 28.1221 18.0891 28.3838 25.3201 23.2103C20.4837 20.4265 15.6017 18.2706 10.8885 20.3132Z",
    fill: "url(#paint0_radial_22_8928)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.050293 23.3588C8.24131 28.1235 18.0891 28.3853 25.3201 23.2117C23.4945 22.1588 21.6612 21.2029 19.828 20.5235C14.5291 24.8529 7.29806 25.4411 0.050293 23.3588Z",
    fill: "url(#paint1_linear_22_8928)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8887 20.3133C15.3965 19.2088 19.7826 21.4515 23.3425 24.4559C24.0255 24.0749 24.6858 23.6571 25.3203 23.2044C20.4839 20.4265 15.6019 18.2706 10.8887 20.3133Z",
    fill: "url(#paint2_linear_22_8928)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0495 10.9588C17.3145 6.70881 19.6041 12.4632 10.8867 20.3147C22.198 15.4073 34.4876 34.7014 44.8131 28.7412C42.2481 28.1132 40.0817 26.6823 38.7276 23.5632C43.418 25.8338 47.7143 25.5838 51.6851 23.2176C48.3822 22.8676 45.3669 21.5765 42.8612 18.6279C49.9112 20.4456 54.7004 18.8706 56.6675 12.9059C50.6369 16.425 42.0533 12.9897 34.0495 10.9588Z",
    fill: "url(#paint3_radial_22_8928)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8734 18.6264C41.4783 18.2595 40.1067 17.8136 38.7657 17.2911C39.6723 18.939 40.9522 20.3676 42.5098 21.4705C35.7017 20.1088 30.9338 14.3985 23.4791 14.1441C18.6427 13.9794 15.962 17.0308 10.8853 20.3205C14.8408 18.1926 19.5859 17.1397 22.9877 17.9264C29.5402 19.4441 32.7122 24.9161 38.3534 26.3088C37.0833 24.933 36.0961 23.3359 35.4446 21.6029C36.4823 22.3475 37.5831 23.0062 38.7353 23.572C43.4256 25.8426 47.722 25.5926 51.6927 23.2264C48.3899 22.8661 45.373 21.575 42.8734 18.6264Z",
    fill: "url(#paint4_linear_22_8928)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7338 23.5617C37.5821 22.9958 36.4818 22.3371 35.4446 21.5926C36.0961 23.3256 37.0834 24.9227 38.3535 26.2985C32.7153 24.9058 29.5432 19.4338 22.9877 17.9161C19.5859 17.1294 14.8438 18.1823 10.8853 20.3103C22.1966 15.4029 34.4862 34.697 44.8116 28.7367C42.2542 28.1117 40.0863 26.675 38.7338 23.5617Z",
    fill: "url(#paint5_linear_22_8928)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0495 10.9588C30.2203 9.98529 27.386 9.53823 25.1846 9.51617C33.4882 11.0294 40.9246 16.2559 47.2124 16.6397C51.3353 16.8882 54.6944 15.9044 56.6737 12.9044C50.637 16.425 42.0534 12.9897 34.0495 10.9588Z",
    fill: "url(#paint6_linear_22_8928)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8738 18.6264C41.4787 18.2595 40.1071 17.8136 38.7661 17.2911C39.6727 18.939 40.9526 20.3676 42.5102 21.4705C45.5727 23.5926 48.6352 24.1176 51.6916 23.2132C48.3902 22.8661 45.3734 21.575 42.8738 18.6264Z",
    fill: "url(#paint7_linear_22_8928)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.734 23.5618C37.5823 22.9959 36.482 22.3372 35.4448 21.5927C36.0963 23.3257 37.0836 24.9228 38.3537 26.2985C40.2219 28.4382 42.4461 28.9294 44.818 28.7382C42.2545 28.1118 40.0865 26.675 38.734 23.5618Z",
    fill: "url(#paint8_linear_22_8928)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5183 20.9411C37.5319 19.9514 34.8893 18.2353 32.0991 16.775C35.3138 18.8926 38.2987 21.3529 42.0519 22.5103C41.4933 22.0325 40.98 21.5074 40.5183 20.9411V20.9411Z",
    fill: "url(#paint9_linear_22_8928)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4238 20.3191C31.5974 22.8661 34.0148 25.9838 37.7437 27.3426C37.3604 26.8371 37.0123 26.3075 36.7015 25.7573C33.6938 24.5176 31.3114 22.1867 28.4238 20.3191Z",
    fill: "url(#paint10_linear_22_8928)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4448 21.5927C35.6734 22.1918 35.9412 22.7764 36.2466 23.3427C37.3049 24.0578 38.4294 24.6766 39.6058 25.1912C39.2658 24.6729 38.9716 24.1278 38.7264 23.5618C37.5773 22.9955 36.4796 22.3368 35.4448 21.5927H35.4448Z",
    fill: "url(#paint11_linear_22_8928)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8738 18.6264C41.4787 18.2595 40.1071 17.8136 38.7661 17.2911C39.0397 17.7787 39.3446 18.2492 39.6789 18.7C41.1183 19.2128 42.5963 19.6179 44.1 19.9117C43.6632 19.5091 43.2537 19.0798 42.8738 18.6264Z",
    fill: "url(#paint12_linear_22_8928)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4796 1.92497C44.2975 0.572027 42.6483 0.182321 40.6371 0.849968C38.2896 1.61762 37.3936 3.39703 35.4979 4.27938C29.4597 7.11026 25.7612 5.5882 19.6758 10.9411C22.2621 9.19261 25.9134 8.89261 34.045 10.9588C34.859 9.78232 35.7779 8.71173 36.8915 7.85144C38.5833 6.55585 40.7968 6.40879 42.7868 5.66026C46.7332 4.1882 46.9431 1.97644 45.4796 1.92497Z",
    fill: "url(#paint13_radial_22_8928)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3417 2.14555C37.8852 2.51908 37.4577 2.91614 37.0181 3.27791C39.6713 3.11908 42.4524 0.424964 45.4799 1.92496C43.2252 0.272023 40.6906 1.68673 38.3417 2.14555Z",
    fill: "url(#paint14_linear_22_8928)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6758 10.9411C21.045 10.0132 22.7185 9.49703 25.1801 9.51467C27.3815 9.53673 30.2158 9.98379 34.0451 10.9573C34.4477 10.3745 34.8856 9.81518 35.3565 9.28232C30.6433 8.50732 23.8276 7.53967 19.6758 10.9411Z",
    fill: "url(#paint15_linear_22_8928)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2915 0.935279C37.4362 4.63087 41.8268 -0.757369 45.4796 1.92498C42.5814 -2.22355 37.85 1.74998 34.2915 0.935279Z",
    fill: "url(#paint16_radial_22_8928)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2915 0.935279C36.2936 2.13381 38.495 1.30293 40.6021 0.861749C42.3486 0.48822 44.0282 0.385278 45.4796 1.92498C42.5814 -2.22355 37.85 1.74998 34.2915 0.935279Z",
    fill: "url(#paint17_linear_22_8928)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4796 1.92497C46.6571 1.96468 46.7499 3.4088 44.6885 4.73821C48.0303 3.3619 51.5169 2.3407 55.087 1.69262C51.8842 1.47429 48.6671 1.55209 45.4796 1.92497V1.92497Z",
    fill: "url(#paint18_radial_22_8928)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4795 1.92499C46.1063 1.94705 46.4227 2.36616 46.2752 2.9544C49.1661 2.27419 52.1159 1.85377 55.0869 1.69852C51.8843 1.47823 48.6672 1.55407 45.4795 1.92499V1.92499Z",
    fill: "url(#paint19_linear_22_8928)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_22_8928",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-8.56518 38.5985) scale(38.6517 11.4785)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9B22D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31F22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22_8928",
    x1: -16.4915,
    y1: 27.3417,
    x2: 11.3692,
    y2: 27.3417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22_8928",
    x1: 1.13978,
    y1: 25.6647,
    x2: 22.6214,
    y2: 25.6647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D151A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D151A",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_22_8928",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.9529 1.00734) scale(87.6259 39.0054)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9B22D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31F22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_22_8928",
    x1: 65.7318,
    y1: 13.7124,
    x2: 22.1007,
    y2: 13.7124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D151A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D151A",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_22_8928",
    x1: 52.2496,
    y1: 17.5781,
    x2: 17.8774,
    y2: 17.5781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D151A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D151A",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_22_8928",
    x1: 79.4348,
    y1: 8.04065,
    x2: 34.9745,
    y2: 8.04065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_22_8928",
    x1: 80.244,
    y1: 23.97,
    x2: 67.8481,
    y2: 5.03594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_22_8928",
    x1: 63.2983,
    y1: 26.6036,
    x2: 47.4083,
    y2: 14.2503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_22_8928",
    x1: 59.7301,
    y1: 10.3795,
    x2: 27.5807,
    y2: 10.3795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D151A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D151A",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_22_8928",
    x1: 48.3232,
    y1: 14.8869,
    x2: 24.587,
    y2: 14.8869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D151A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D151A",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_22_8928",
    x1: 30.7682,
    y1: 26.6904,
    x2: 38.3978,
    y2: 26.6904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D151A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D151A",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_22_8928",
    x1: 29.6578,
    y1: 22.0409,
    x2: 43.6588,
    y2: 22.0409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D151A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D151A",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_22_8928",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.0641 -12.8839) scale(62.6573 24.529)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9B22D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31F22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_22_8928",
    x1: 59.659,
    y1: -0.819231,
    x2: 35.6184,
    y2: -0.819231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D151A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D151A",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_22_8928",
    x1: 4.9155,
    y1: 11.9397,
    x2: 33.2981,
    y2: 11.9397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D151A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D151A",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_22_8928",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.6197 0.327925) scale(18.8527 3.84207)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9B22D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31F22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_22_8928",
    x1: 28.1391,
    y1: 2.07835,
    x2: 41.1011,
    y2: 2.07835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_22_8928",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.2491 2.8338) scale(24.6369 7.502)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9B22D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31F22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_22_8928",
    x1: 60.2869,
    y1: 1.27004,
    x2: 46.4669,
    y2: 1.27004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.5f3242cb28457801555943c546caa54f.svg";
export { ForwardRef as ReactComponent };